import React, { useEffect, useState } from 'react';
import { UserServices } from '../../../services';
import './style.css';
import { Layout, Table, Space, Button, Modal, Input } from 'antd';
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
const { Content } = Layout;

function Users() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [submitError, setSubmitError] = useState(false);

  const [users, setUsers] = useState([]);
  const [showAddUserModal, setShowAddUserModal] = useState(false);
  const [showUpdateUserModal, setShowUpdateUserModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [userId, setUserId] = useState(null);

  async function fetchUsers() {
    try {
      const response = await UserServices.fetchUsers();
      setUsers(response.data);
    } catch(error) {
      console.log(error);
    }
  }

  function handleShowUpdateUserModal(user) {
    setUserId(user.id);
    setUsername(user.username);
    setShowUpdateUserModal(true);
  }

  async function handleDeleteUser(user) {
    setIsLoading(true);
    try {
      await UserServices.deleteUser(user.id);
      await fetchUsers();
    } catch(error) {
      console.log(error);
    }
    setIsLoading(false);
  }

  const columns = [
    {
      title: 'Usuário',
      dataIndex: 'username',
      key: 'username',
    },
    {
      title: 'Data de Criação',
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: text => text.split('T')[0].split('-').reverse().join('/'),
    },
    {
      title: 'Ações',
      key: 'action',
      render: (_, record) => (
        <Space size="middle">
          <Button
            onClick={() => handleShowUpdateUserModal(record)}
          >
            <EditOutlined />
          </Button>
          <Button
            onClick={() => handleDeleteUser(record)}
          >
            <DeleteOutlined />
          </Button>
        </Space>
      ),
    },
  ];

  useEffect(() => {
    async function fetchUsers() {
      try {
        const response = await UserServices.fetchUsers();
        setUsers(response.data);
      } catch(error) {
        console.log(error);
      }
    }

    fetchUsers();
  }, []);

  function handleCloseAddUserModal() {
    setUsername('');
    setPassword('');
    setShowAddUserModal(false);
  }

  function handleCloseUpdateUserModal() {
    setUsername('');
    setPassword('');
    setShowUpdateUserModal(false);
  }

  async function handleAddUser() {
    if(username.length < 3 || password.length < 6) {
      return setSubmitError('Os campos devem ser preenchidos corretamente.');
    }
    setSubmitError(false);
    setIsLoading(true);
    try {
      await UserServices.addUser({ username, password });
      await fetchUsers();
      handleCloseAddUserModal();
    } catch (error) {
      console.log(error);
    }
    setIsLoading(false);
  }

  async function handleUpdateUser() {
    const payload = {};
    if(username.length > 2) {
      payload.username = username;
    }
    if(password.length > 5) {
      payload.password = password;
    }
    setSubmitError(false);
    setIsLoading(true);
    try {
      await UserServices.updateUser(userId, { username, password });
      await fetchUsers();
      handleCloseUpdateUserModal();
    } catch (error) {
      console.log(error);
    }
    setIsLoading(false);
  }
  return (
    <Content style={{ margin: '24px 16px 0' }}>
      <Modal
        visible={showAddUserModal}
        title="Adicionar Usuário"
        onOk={handleAddUser}
        onCancel={handleCloseAddUserModal}
        footer={[
          <Button key="back" onClick={handleCloseAddUserModal}>
            Cancelar
          </Button>,
          <Button key="submit" type="primary" loading={isLoading} onClick={handleAddUser}>
            Cadastrar
          </Button>,
        ]}
      >
        <Input
          className="login-input"
          placeholder="Usuário"
          size="large"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />
        <Input.Password
          className="login-input"
          placeholder="Senha"
          size="large"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
      </Modal>
      <Modal
        visible={showUpdateUserModal}
        title="Atualizar Usuário"
        onOk={handleUpdateUser}
        onCancel={handleCloseUpdateUserModal}
        footer={[
          <Button key="back" onClick={handleCloseUpdateUserModal}>
            Cancelar
          </Button>,
          <Button key="submit" type="primary" loading={isLoading} onClick={handleUpdateUser}>
            Atualizar
          </Button>,
        ]}
      >
        <Input
          className="login-input"
          placeholder="Usuário"
          size="large"
          defaultValue={username || ''}
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />
        <Input.Password
          className="login-input"
          placeholder="Senha"
          size="large"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
      </Modal>
      <div className="site-layout-background" style={{ padding: 24, minHeight: 360 }}>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          Usuários
          <Button className="button-add-user" type="primary" onClick={() => setShowAddUserModal(true)}>
            Adicionar usuário
          </Button>
        </div>
        {users.length > 0 && (
          <Table style={{ marginTop: '40px' }} columns={columns} dataSource={users} />
        )}
      </div>
    </Content>
  );
}

export default Users;